import React, { useEffect, useState } from 'react'
import { Form, Button, Row, Col } from 'react-bootstrap'

const CreditCard = ({ amount, force }) => {

    const [ store, setStore ] = useState(force)
    
    return (
        <div>
            { amount > 0 ? <h6>Total: {amount}</h6> : '' }
            <Form>
                <Form.Group>
                    <Form.Label>Enter credit card number</Form.Label>
                    <Form.Control type='number'/>
                </Form.Group>
                <br/>
                <Form.Check type='checkbox' checked={store} disabled={force} onChange={(e) => setStore(e.value)} label='Save information'/>
            </Form>
        </div>
    )
}

export default CreditCard